import { useCallback, useMemo, useSyncExternalStore } from 'react';
import { modalStore } from './modalStore';

export const useModalState = (): {
  isOpen: (name: string) => boolean;
  openModal: (name: string) => void;
  closeModal: (name: string, callback?: () => void) => void;
  openModals: ReadonlySet<string>;
} => {
  const openModalIds = useSyncExternalStore(
    modalStore.subscribe,
    modalStore.getSnapshot,
    modalStore.getServerSnapshot
  );

  const openModals = useMemo(() => new Set(openModalIds), [openModalIds]);

  const isOpen = useCallback((name: string) => openModals.has(name), [openModals]);

  const openModal = useCallback((name: string) => {
    modalStore.openModal(name);
  }, []);

  const closeModal = useCallback((name: string, callback?: () => void) => {
    modalStore.closeModal(name, callback);
  }, []);

  return { isOpen, openModal, closeModal, openModals };
};
